import { cn } from '@/lib/utils';
import type { AppNode } from '../types';
import { DescriptionPanel, type DescriptionPanelHelpInfo } from './DescriptionPanel';
import { LogPanel } from './LogPanel';

type FlowInspectorPanelProps = {
  help?: DescriptionPanelHelpInfo;
  selectedNode?: AppNode;
  logs: string[];
  className?: string;
  priority?: 'description' | 'logs';
  onClearLogs: () => void;
};

export function FlowInspectorPanel({
  help,
  selectedNode,
  logs,
  className,
  priority = 'description',
  onClearLogs,
}: FlowInspectorPanelProps) {
  return (
    <div className={cn('flex h-full flex-col bg-background', className)}>
      <div className={`flow-inspector-grid grid min-h-0 flex-1 divide-x divide-border overflow-hidden is-${priority}-priority`}>
        <div className="min-h-0 min-w-0 overflow-hidden">
          <DescriptionPanel help={help} selectedNode={selectedNode} />
        </div>
        <div className="min-h-0 min-w-0 overflow-hidden">
          <LogPanel logs={logs} onClearLogs={onClearLogs} />
        </div>
      </div>
    </div>
  );
}
